const ErrorUtil = require("../../../../shared/ErrorUtil");

const logReadAloudErrorAndGetReturnValue = function(devMessage, type, data) {
	ErrorUtil.log(type, devMessage, data);
	return process.env.NODE_ENV !== "production" ? devMessage : null;
};

module.exports = {
	logReadAloudErrorAndGetReturnValue,
};
